import { Box, Typography } from '@mui/material';
import NoResult from 'assets/NoResult.svg';

export const EmptyStateView = () => {
  return (
    <Box display='flex' flexDirection='column' alignItems='center' minHeight={300}>
      <img src={NoResult} alt='No data found' />
      <Typography color='secondary' marginTop={2}>
        No Data Found
      </Typography>
    </Box>
  );
};
